'use strict';

var $       = require('jquery');
var Core    = require('../core/core.js');

/**
 * Creates a interactive window object
 *
 * @class
 */

class WindowLayer extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'layerColor': "#000000",
                'title': ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__window__layer js-editor__window__layer clearfix'>

                <div class='editor__window__layer__layercircle float' style='background: <%= layerColor %>'></div>

                <div class='editor__window__layer__title float'><%- title %></div>

                <a class='js-editor__window__layer__righticon'>
                    <div class='editor__window__layer__righticon cio-ui-icon editor__window__layer__icon right'>
                        <%= embedded_svg('icon-layer-visible.svg') %>
                    </div>
                </a>
                <a class='js-editor__window__layer__righticon__toggle hide'>
                    <div class='editor__window__layer__righticon__toggle editor__window__layer__icon cio-ui-icon right'>
                        <%= embedded_svg('icon-layer-hidden.svg') %>
                    </div>
                </a>

            </div>
        `;

        super.render();

        /**
         * Click right icon event
         *
         * @fires WindowLayer#_rightIconClicked
         */

         this.$el.on('click', this._clicked);

        /**
         * Click right icon event
         *
         * @fires WindowLayer#_rightIconClicked
         */

         $('.js-editor__window__layer__righticon', this.$el).on('click', this._rightIconClicked);

        /**
         * Click right toggle icon event
         *
         * @fires WindowLayer#_rightIconToggleClicked
         */

         $('.js-editor__window__layer__righticon__toggle', this.$el).on('click', this._rightIconToggleClicked);
    }

    /**
     * @event WindowLayer#Cioui:WindowLayer:clicked
     * @property {String}Cioui:WindowLayer:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:WindowLayer:clicked', e);
    }

    /**
     * @event WindowLayer#Cioui:WindowLayer:rightIconClick
     * @property {String}Cioui:WindowLayer:rightIconClick
     * @returns {Object} event - native click Event
     */

    _rightIconClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:WindowLayer:rightIconClick', e);
    }

    /**
     * @event WindowLayer#Cioui:WindowLayer:rightIconToggleClick
     * @property {String}Cioui:WindowLayer:rightIconToggleClick
     * @returns {Object} event - native click Event
     */

    _rightIconToggleClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:WindowLayer:rightIconToggleClick', e);
    }


    setActive(){
        this.$el.addClass('active');
    }

    setInActive(){
        this.$el.removeClass('active');
    }
    

    /**
     * left Icon Active
     * makes the left icon active
     */
    rightIconActive(){
        $('.js-editor__window__layer__righticon', this.$el).show();
        $('.js-editor__window__layer__righticon__toggle', this.$el).hide();
    }

    /**
     * right toggle Icon Active
     * makes the right toggle icon active
     */
    rightIconInactive(){
        $('.js-editor__window__layer__righticon', this.$el).hide();
        $('.js-editor__window__layer__righticon__toggle', this.$el).show();
    }
}
module.exports = WindowLayer;